import { SettingsService as BaseSettingsService } from '../shared/SettingsService';

export class SettingsService extends BaseSettingsService {
    static initialize(): SettingsService {
        const o_order = window.o_order ?? {};
        o_order.settings = o_order.settings ?? {};

        if (!o_order.settings.service) {
            o_order.settings.service = new SettingsService();
        }
        return o_order.settings.service;
    }
}
